import { AfterContentInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[focusSearchbar]'
})

export class AutoFocusDirective implements AfterContentInit {
    @Input() public appAutoFocus: boolean;

    constructor (private elRef: ElementRef) {}

    public ngAfterContentInit(): void {
        setTimeout( () => {
          this.elRef.nativeElement.setFocus()
        }, 500)
    }
}
